import { FaGithub, FaYoutube } from "react-icons/fa"
import { LoginIcon } from "../../components/shared/icons/LoginIcon"

export const socialNetworks = [
  {
    name: `Github`,
    url: `https://github.com/gatsbyjs`,
    icon: FaGithub,
  },
  {
    name: `Youtube`,
    url: `https://www.youtube.com/gatsbyjs`,
    icon: FaYoutube,
  },
]

const OpenSource = {
  items: [
    {
      url: `/docs/`,
      text: `Documentation`,
    },
    {
      url: `/docs/quick-start/`,
      text: `Quick Start`,
    },
    {
      url: `/docs/tutorial/`,
      text: `Tutorials`,
    },
    {
      url: `/docs/how-to/`,
      text: `How-To Guides`,
    },
    {
      url: `/docs/reference/`,
      text: `Reference Guides`,
    },
    {
      url: `/docs/conceptual/`,
      text: `Conceptual Guides`,
    },
    {
      url: `/docs/reference/gatsby-cli/`,
      text: `Gatsby CLI`,
    },
    {
      url: `https://github.com/gatsbyjs`,
      text: `Github`,
      Icon: FaGithub,
      shifted: true,
    },
  ],
  heading: {
    text: `Open Source`,
  },
}

const Features = {
  items: [
    {
      url: "/features/",
      text: "Comparison",
    },
    {
      url: "/plugins/",
      text: "Plugins",
    },
    {
      url: "/docs/themes/",
      text: "Themes",
    },
    {
      url: "/docs/recipes/",
      text: "Recipes",
    },
    {
      url: "/starters/",
      text: "Starters",
    },
    {
      url: "/use-cases/",
      text: "Use Cases",
    },
  ],
  heading: {
    text: "Features",
  },
}

const Community = {
  items: [
    {
      url: "/contributing/",
      text: "Contributing",
    },
    {
      url: "https://store.gatsbyjs.org/",
      text: "Swag Store",
    },
    {
      url: "/contributing/code-of-conduct/",
      text: "Code of Conduct",
    },
    {
      url: "/contributing/gatsby-style-guide/",
      text: "Style Guide",
    },
    {
      url: "https://www.twitch.tv/gatsbyjs",
      text: "Live Streams",
    },
  ],
  heading: {
    text: "Community",
  },
}

const Events = {
  items: [
    {
      url: "/resources/webinars/",
      text: "Webinars",
    },
    {
      url: "https://gatsbyconf.com/",
      text: "GatsbyConf 2022",
    },
  ],
  heading: {
    text: "Events",
  },
}

export const navData = [OpenSource, Features, Community, Events]
